module.exports = __webpack_public_path__ + "img/img5594_comp.8c4526b9.jpg";